import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";
import { getSessionId, getTodayString, getVisitorId } from "./session";
import { addDailyTime, incrementDailyMetric } from "./dailyMetrics";

function getDeviceType() {
  const ua = navigator.userAgent.toLowerCase();

  if (/mobile|android|iphone|ipod/.test(ua)) return "mobile";
  if (/ipad|tablet/.test(ua)) return "tablet";
  return "desktop";
}

function getUtmData() {
  const params = new URLSearchParams(window.location.search);

  return {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
    utm_content: params.get("utm_content") || "",
    utm_term: params.get("utm_term") || "",
  };
}

export async function trackEvent(eventName, extraData = {}) {
  try {
    const visitorId = getVisitorId();
    const sessionId = getSessionId();
    const date = getTodayString();

    const payload = {
      event: eventName,
      page: window.location.pathname,
      fullUrl: window.location.href,
      visitorId,
      sessionId,
      date,
      deviceType: getDeviceType(),
      referrer: document.referrer || "",
      ...getUtmData(),
      ...extraData,
      createdAt: serverTimestamp(),
    };

    await addDoc(collection(db, "events"), payload);

    if (eventName === "page_view") {
      await incrementDailyMetric(date, "pageViews", 1);
    }

    if (eventName === "session_start") {
      await incrementDailyMetric(date, "sessions", 1);
    }

    if (eventName === "whatsapp_click") {
      await incrementDailyMetric(date, "whatsappClicks", 1);
    }

    if (eventName === "page_view" && extraData.isUniqueVisitorToday) {
      await incrementDailyMetric(date, "uniqueVisitors", 1);
    }

    if (eventName === "time_on_page" && typeof extraData.durationSeconds === "number") {
      await addDailyTime(date, extraData.durationSeconds);
    }
  } catch (error) {
    console.error("Erro ao salvar evento:", error);
  }
}